(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ktt-shop-continuation"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById('KttContinuation');
    if (!root || root.dataset.initialized || typeof HTMLDialogElement === 'undefined') return;
    root.dataset.initialized = 'true';
    const words = Object.fromEntries([...root.querySelectorAll('[data-ktt-word]')].map(node => [node.dataset.kttWord, node.textContent]));
    const key = 'ktt.shop.continuation.v1';
    const handlePattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
    const maxRecords = 96;
    const limits = { saved: 24, recent: 12 };
    const emptyStamp = () => ({ time: 0, id: '' });
    const emptyState = () => ({ version: 1, saved: [], recent: [], clearSaved: emptyStamp(), clearRecent: emptyStamp() });
    const compare = (a, b) => a.time - b.time || a.id.localeCompare(b.id);
    const validHandle = value => typeof value === 'string' && value.length <= 180 && handlePattern.test(value);
    const validStamp = value => value && Number.isSafeInteger(value.time) && value.time >= 0 && value.time <= Date.now() + 31536000000 && typeof value.id === 'string' && (value.time === 0 && value.id === '' || /^[a-f0-9]{32}$/.test(value.id));
    const normalize = (records, clear, limit) => {
      const latest = new Map();
      for (const record of records) if (compare(record, clear) > 0 && (!latest.has(record.handle) || compare(record, latest.get(record.handle)) > 0)) latest.set(record.handle, record);
      const ordered = [...latest.values()].sort((a, b) => compare(b, a));
      const keptActive = ordered.filter(record => !record.deleted).slice(0, limit);
      const keptDeleted = ordered.filter(record => record.deleted).slice(0, maxRecords - keptActive.length);
      return [...keptActive, ...keptDeleted].sort((a, b) => compare(b, a));
    };
    const merge = (a, b) => {
      const clearSaved = compare(a.clearSaved, b.clearSaved) >= 0 ? a.clearSaved : b.clearSaved;
      const clearRecent = compare(a.clearRecent, b.clearRecent) >= 0 ? a.clearRecent : b.clearRecent;
      return { version: 1, saved: normalize([...a.saved, ...b.saved], clearSaved, limits.saved), recent: normalize([...a.recent, ...b.recent], clearRecent, limits.recent), clearSaved, clearRecent };
    };
    const parse = raw => {
      if (raw === null) return emptyState();
      if (typeof raw !== 'string' || raw.length > 65536) throw new Error('corrupt');
      const data = JSON.parse(raw);
      if (!data || data.version !== 1 || !validStamp(data.clearSaved) || !validStamp(data.clearRecent)) throw new Error('corrupt');
      for (const kind of ['saved', 'recent']) {
        if (!Array.isArray(data[kind]) || data[kind].length > maxRecords) throw new Error('corrupt');
        if (data[kind].some(item => !item || !validHandle(item.handle) || !validStamp(item) || typeof item.deleted !== 'boolean')) throw new Error('corrupt');
        data[kind] = data[kind].map(({ handle, time, id, deleted }) => ({ handle, time, id, deleted }));
      }
      return merge(emptyState(), { version: 1, saved: data.saved, recent: data.recent, clearSaved: { time: data.clearSaved.time, id: data.clearSaved.id }, clearRecent: { time: data.clearRecent.time, id: data.clearRecent.id } });
    };
    const read = () => {
      let raw;
      try { raw = localStorage.getItem(key); } catch { return { error: 'storage_read_error' }; }
      try { return { state: parse(raw), raw }; } catch { return { error: 'storage_corrupt' }; }
    };
    const initial = read();
    let state = initial.state || emptyState();
    let storageError = initial.error || '';
    const active = kind => state[kind].filter(record => !record.deleted);
    const isSaved = handle => active('saved').some(record => record.handle === handle);
    const stamp = current => ({ time: Math.max(Date.now(), ...current.saved.map(r => r.time + 1), ...current.recent.map(r => r.time + 1), current.clearSaved.time + 1, current.clearRecent.time + 1), id: crypto.randomUUID().replaceAll('-', '') });
    const dialog = root.querySelector('dialog');
    const toolbar = root.querySelector('[data-ktt-continuation-toolbar]');
    const trigger = root.querySelector('[data-ktt-open-products]');
    const announcement = root.querySelector('[data-ktt-announcement]');
    const fetchStatus = root.querySelector('[data-ktt-fetch-status]');
    let returnFocus = null;
    let requestGeneration = 0;
    let controller = null;
    let productData = new Map();
    let currentCurrency = '';
    let fetching = false;
    const say = message => {
      const visible = dialog.open ? root.querySelector('[data-ktt-action-status]') : document.querySelector('[data-ktt-inline-status]');
      if (visible) visible.textContent = dialog.open && storageError ? '' : message;
      announcement.textContent = ''; requestAnimationFrame(() => { announcement.textContent = message; });
    };
    const element = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node; };
    const routeRoot = () => {
      const candidate = new URL(window.Shopify?.routes?.root || '/', location.origin);
      if (candidate.origin !== location.origin || !candidate.pathname.endsWith('/')) throw new Error('route');
      return candidate.pathname;
    };
    const productUrl = handle => routeRoot() + 'products/' + encodeURIComponent(handle);
    const setStorageFeedback = () => {
      const feedback = root.querySelector('[data-ktt-storage-error]');
      feedback.hidden = !storageError;
      feedback.textContent = storageError ? words[storageError] : '';
      root.querySelector('[data-ktt-reset]').hidden = storageError !== 'storage_corrupt';
    };
    const updateButtons = () => {
      const count = active('saved').length;
      trigger.setAttribute('aria-label', `${words.open_saved} (${count})`);
      trigger.querySelector('[data-ktt-saved-count]').textContent = String(count);
      for (const button of document.querySelectorAll('[data-ktt-save-product]')) {
        const saved = isSaved(button.dataset.kttSaveProduct);
        button.textContent = saved ? words.saved : words.save;
        button.setAttribute('aria-pressed', String(saved));
      }
      setStorageFeedback();
    };
    const write = (transform, success) => {
      const latest = read();
      if (latest.error) { storageError = latest.error; updateButtons(); say(words[storageError]); return false; }
      const base = merge(state, latest.state);
      let proposed;
      try { proposed = transform(base, stamp(base)); } catch { storageError = 'storage_error'; updateButtons(); say(words.storage_error); return false; }
      if (!proposed) return false;
      const next = merge(emptyState(), proposed);
      try { localStorage.setItem(key, JSON.stringify(next)); } catch { storageError = 'storage_error'; updateButtons(); say(words.storage_error); return false; }
      state = next;
      storageError = '';
      updateButtons();
      if (success) say(words[success]);
      if (dialog.open) refresh();
      return true;
    };
    const changeRecord = (kind, handle, deleted) => write((base, nextStamp) => {
      const already = base.saved.some(record => record.handle === handle && !record.deleted);
      if (kind === 'saved' && !deleted && !already && base.saved.filter(record => !record.deleted).length >= limits.saved) { say(words.limit); return null; }
      return { ...base, [kind]: [...base[kind].filter(record => record.handle !== handle), { handle, ...nextStamp, deleted }] };
    }, deleted ? 'removed_notice' : kind === 'saved' ? 'saved_notice' : null);
    const safeImage = source => {
      try { const url = new URL(source, location.origin); return url.protocol === 'https:' && [location.hostname, 'cdn.shopify.com'].includes(url.hostname) ? url.href : ''; } catch { return ''; }
    };
    const render = () => {
      const focused = document.activeElement;
      const oldCard = focused?.closest('.ktt-continuation-card');
      const focusKey = oldCard ? { handle: oldCard.dataset.handle, kind: oldCard.dataset.kind, action: focused.hasAttribute('data-ktt-save-product') ? 'save' : focused.hasAttribute('data-ktt-remove') ? 'remove' : 'link' } : null;
      for (const kind of ['saved', 'recent']) {
        const list = root.querySelector(`[data-ktt-list="${kind}"]`);
        const records = active(kind);
        const fragment = document.createDocumentFragment();
        for (const record of records) {
          const data = productData.get(record.handle);
          const item = element('li', 'ktt-continuation-card'); item.dataset.handle = record.handle; item.dataset.kind = kind;
          const link = element('a', 'ktt-continuation-product');
          link.href = productUrl(record.handle);
          const media = element('span', 'ktt-continuation-media');
          if (data?.image) { const image = element('img'); image.src = data.image; image.alt = ''; image.width = 88; image.height = 88; image.loading = 'lazy'; image.addEventListener('error', () => image.remove(), { once: true }); media.append(image); }
          const copy = element('span', 'ktt-continuation-copy');
          const title = data?.title || record.handle.replaceAll('-', ' ');
          const titleNode = element('span', 'ktt-continuation-product-title', title);
          titleNode.id = `ktt-${kind}-${record.handle}`;
          copy.append(titleNode);
          if (data?.price !== null && data?.price !== undefined && currentCurrency) {
            try { const price = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currentCurrency, currencyDisplay: 'code' }).format(data.price / 100); copy.append(element('span', 'ktt-continuation-product-price', (data.varies ? words.from + ' ' : '') + price)); } catch {}
          }
          const status = !data ? words.loading : data.error ? data.error === 'unavailable' ? words.unavailable : words.details_error : data.available ? words.available : words.unavailable;
          copy.append(element('span', 'ktt-continuation-product-meta', status));
          link.append(media, copy);
          const actions = element('div', 'ktt-continuation-card-actions');
          if (kind === 'recent') { const save = element('button', 'ktt-continuation-action', isSaved(record.handle) ? words.saved : words.save); save.type = 'button'; save.dataset.kttSaveProduct = record.handle; save.setAttribute('aria-pressed', String(isSaved(record.handle))); save.setAttribute('aria-describedby', titleNode.id); actions.append(save); }
          const remove = element('button', 'ktt-continuation-action', words.remove); remove.type = 'button'; remove.dataset.kttRemove = kind; remove.dataset.handle = record.handle; remove.setAttribute('aria-describedby', titleNode.id); actions.append(remove);
          item.append(link, actions); fragment.append(item);
        }
        list.replaceChildren(fragment);
        root.querySelector(`[data-ktt-empty="${kind}"]`).hidden = records.length > 0;
        root.querySelector(`[data-ktt-clear="${kind}"]`).disabled = records.length === 0;
      }
      updateButtons();
      if (focusKey && dialog.open) {
        const cards = [...root.querySelectorAll(`[data-ktt-list="${focusKey.kind}"] .ktt-continuation-card`)];
        const card = cards.find(node => node.dataset.handle === focusKey.handle) || cards[0];
        const next = card?.querySelector(focusKey.action === 'save' ? '[data-ktt-save-product]' : focusKey.action === 'remove' ? '[data-ktt-remove]' : 'a') || root.querySelector('[data-ktt-close]');
        next.focus({ preventScroll: true });
      }
    };
    const requestJson = async (url, signal) => {
      const requestController = new AbortController();
      const abort = () => requestController.abort();
      if (signal.aborted) abort();
      signal.addEventListener('abort', abort, { once: true });
      const timeout = setTimeout(abort, 8000);
      try {
        const response = await fetch(url, { signal: requestController.signal, credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(response.status === 404 ? 'unavailable' : 'fetch');
        const body = await response.text();
        if (body.length > 1500000) throw new Error('fetch');
        return JSON.parse(body);
      } finally { clearTimeout(timeout); signal.removeEventListener('abort', abort); }
    };
    async function refresh() {
      if (!dialog.open) return;
      controller?.abort();
      controller = new AbortController();
      const signal = controller.signal;
      const generation = ++requestGeneration;
      const localeRoot = routeRoot();
      productData = new Map(); currentCurrency = ''; fetching = true; render();
      const handles = [...new Set([...active('saved'), ...active('recent')].map(record => record.handle))];
      fetchStatus.textContent = handles.length ? words.refreshing : '';
      if (!handles.length) { fetching = false; return; }
      let currencyFailed = false; let candidateCurrency = '';
      try { const data = await requestJson(localeRoot + 'cart.js', signal); if (!/^[A-Z]{3}$/.test(data.currency)) throw new Error('currency'); candidateCurrency = data.currency; } catch { currencyFailed = true; }
      if (signal.aborted || generation !== requestGeneration) return;
      currentCurrency = candidateCurrency;
      let cursor = 0; let failures = 0;
      const worker = async () => {
        while (cursor < handles.length) {
          const handle = handles[cursor++]; let result;
          try {
            const data = await requestJson(localeRoot + 'products/' + encodeURIComponent(handle) + '.js', signal);
            if (data.handle !== handle || typeof data.title !== 'string' || !data.title.trim() || typeof data.available !== 'boolean') throw new Error('fetch');
            const price = data.price_min ?? data.price;
            result = { title: data.title.slice(0, 300), price: Number.isSafeInteger(price) && price >= 0 ? price : null, varies: data.price_varies === true, available: data.available, image: safeImage(typeof data.featured_image === 'string' ? data.featured_image : data.featured_image?.src || '') };
          } catch (error) { result = { error: error.message === 'unavailable' ? 'unavailable' : 'fetch' }; failures += 1; }
          if (signal.aborted || generation !== requestGeneration || !dialog.open) return;
          productData.set(handle, result);
        }
      };
      await Promise.all(Array.from({ length: Math.min(4, handles.length) }, worker));
      if (signal.aborted || generation !== requestGeneration || !dialog.open) return;
      fetching = false; render();
      fetchStatus.textContent = failures ? words.partial_error : currencyFailed ? words.price_error : words.refreshed;
    }
    const mountSave = () => {
      if (root.dataset.page !== 'product' || !validHandle(root.dataset.product)) return;
      const details = document.querySelector('main .product-details');
      const buy = details?.querySelector('product-form-component');
      if (!buy || details.querySelector('.ktt-continuation-save')) return;
      const button = element('button', 'ktt-continuation-save'); button.type = 'button'; button.dataset.kttSaveProduct = root.dataset.product;
      const status = element('p', 'ktt-continuation-save-status'); status.dataset.kttInlineStatus = ''; status.id = 'KttContinuationSaveStatus'; button.setAttribute('aria-describedby', status.id);
      buy.after(button, status); updateButtons();
    };
    const placeTrigger = () => {
      const main = document.querySelector('main');
      if (!main) return;
      const actions = document.querySelector('header header-actions');
      if (actions) {
        trigger.dataset.header = 'true'; actions.prepend(trigger);
        const box = trigger.getBoundingClientRect();
        const actionBox = actions.getBoundingClientRect();
        const others = [...document.querySelectorAll('header button, header a, header img')].filter(node => node !== trigger && !trigger.contains(node) && !node.contains(trigger));
        const overlaps = others.some(node => { const r = node.getBoundingClientRect(); return r.width > 0 && r.height > 0 && getComputedStyle(node).visibility !== 'hidden' && !node.closest('[aria-hidden="true"], [inert]') && r.left < box.right - 1 && r.right > box.left + 1 && r.top < box.bottom - 1 && r.bottom > box.top + 1; });
        if (box.width >= 44 && box.left >= 0 && box.right <= innerWidth && actionBox.height <= 60 && !overlaps) { toolbar.hidden = true; return; }
      }
      delete trigger.dataset.header; toolbar.prepend(trigger); toolbar.hidden = false; main.prepend(toolbar);
    };
    let placeFrame = 0;
    const schedulePlace = () => { if (!placeFrame) placeFrame = requestAnimationFrame(() => { placeFrame = 0; placeTrigger(); }); };
    document.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : null;
      const opener = target?.closest('[data-ktt-open-products]');
      if (opener) { event.preventDefault(); if (!dialog.open) { returnFocus = opener; root.querySelector('[data-ktt-action-status]').textContent = ''; dialog.showModal(); refresh(); } return; }
      const save = target?.closest('[data-ktt-save-product]');
      if (save && validHandle(save.dataset.kttSaveProduct)) changeRecord('saved', save.dataset.kttSaveProduct, isSaved(save.dataset.kttSaveProduct));
    });
    dialog.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : null;
      if (target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); }
      if (target?.closest('[data-ktt-close]')) dialog.close();
      if (target?.closest('[data-ktt-refresh]')) refresh();
      const remove = target?.closest('[data-ktt-remove]');
      if (remove && ['saved', 'recent'].includes(remove.dataset.kttRemove) && validHandle(remove.dataset.handle)) changeRecord(remove.dataset.kttRemove, remove.dataset.handle, true);
      const clear = target?.closest('[data-ktt-clear]');
      if (clear && ['saved', 'recent'].includes(clear.dataset.kttClear)) { const kind = clear.dataset.kttClear; if (confirm(words[kind === 'saved' ? 'confirm_saved' : 'confirm_recent'])) write((base, nextStamp) => ({ ...base, [kind]: [], [kind === 'saved' ? 'clearSaved' : 'clearRecent']: nextStamp }), 'cleared_notice'); }
      if (target?.closest('[data-ktt-reset]') && confirm(words.confirm_reset)) {
        try { const next = emptyState(); next.clearSaved = stamp(next); next.clearRecent = next.clearSaved; localStorage.setItem(key, JSON.stringify(next)); state = next; storageError = ''; say(words.cleared_notice); render(); refresh(); } catch { storageError = 'storage_error'; setStorageFeedback(); say(words.storage_error); }
      }
    });
    dialog.addEventListener('close', () => { controller?.abort(); requestGeneration += 1; fetching = false; productData.clear(); currentCurrency = ''; if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true }); else trigger.focus({ preventScroll: true }); });
    window.addEventListener('storage', event => {
      if (event.key !== key && event.key !== null) return;
      if (event.newValue === null) { state = emptyState(); storageError = ''; updateButtons(); if (dialog.open) refresh(); return; }
      let incoming;
      try { incoming = parse(event.newValue); } catch { storageError = 'storage_corrupt'; setStorageFeedback(); return; }
      const next = merge(state, incoming);
      const serialized = JSON.stringify(next);
      state = next; storageError = '';
      if (serialized !== JSON.stringify(incoming)) { try { localStorage.setItem(key, serialized); } catch { storageError = 'storage_read_error'; } }
      updateButtons(); if (dialog.open) refresh();
    });
    window.addEventListener('resize', schedulePlace);
    document.addEventListener('shopify:section:load', () => { schedulePlace(); mountSave(); });
    document.addEventListener('variant:update', mountSave);
    const ready = () => {
      placeTrigger(); mountSave(); updateButtons();
      if (document.fonts?.ready) document.fonts.ready.then(schedulePlace);
      if (root.dataset.page === 'product' && validHandle(root.dataset.product) && document.querySelector('main .product-details h1')) {
        const visit = () => { if (document.visibilityState === 'hidden') return; document.removeEventListener('visibilitychange', visit); requestAnimationFrame(() => changeRecord('recent', root.dataset.product, false)); };
        if (document.visibilityState === 'hidden') document.addEventListener('visibilitychange', visit); else visit();
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ktt-shop-design"] && !Shopify.designMode) return;
  try {
    const initializeKttShopDesign = () => {
    const config = document.querySelector('.ktt-shop-overhaul [data-ktt-shop-design]');
    const main = document.querySelector('.ktt-shop-overhaul main[data-template^="product"]');
    if (!config || !main || config.dataset.kttShopPage !== 'product') return;
    if (!config.dataset.sizeGuide || !config.dataset.fitHelp) return;

    const findGuide = (details) => {
      const descriptions = [...details.querySelectorAll('rte-formatter')];
      for (const description of descriptions) {
        for (const table of description.querySelectorAll('table')) {
          const region = table.closest('[role="region"]');
          const label = [table.caption?.textContent, table.rows[0]?.textContent, region?.getAttribute('aria-label')].join(' ');
          if (!/\b(size|sizing|measurements?)\b/i.test(label)) continue;
          const target = region || table;
          if (!target.id) {
            const base = `ktt-fit-${details.id || 'product'}`;
            let id = base;
            let index = 1;
            while (document.getElementById(id)) id = `${base}-${index++}`;
            target.id = id;
          }
          target.classList.add('ktt-shop-fit-target');
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          return { href: `#${target.id}`, target };
        }
      }
      for (const description of descriptions) {
        for (const link of description.querySelectorAll('a[href]')) {
          try {
            const url = new URL(link.getAttribute('href'), location.href);
            if (url.protocol !== 'https:') continue;
            const supplier = /^(www\.)?printful\.com$/.test(url.hostname) && url.pathname === '/custom-products/size-guide';
            const ktt = /^(www\.)?kttgoodsco\.com$/.test(url.hostname) && url.pathname === '/tv-d1-sizing';
            if (supplier || ktt) return { href: url.href, target: null };
          } catch {}
        }
      }
      return null;
    };

    const enhance = () => {
      for (const details of main.querySelectorAll('.product-details')) {
        if (details.closest('quick-add-dialog, product-card')) continue;
        const picker = details.querySelector('variant-picker[data-template-product-match="true"]');
        if (!picker || picker.querySelector('[data-ktt-western-fit]')) continue;
        const guide = findGuide(details);
        let help = picker.querySelector('.ktt-shop-fit-help');
        if (!guide) {
          help?.remove();
          continue;
        }
        if (!help) {
          help = document.createElement('div');
          help.className = 'ktt-shop-fit-help';
          const link = document.createElement('a');
          link.textContent = config.dataset.sizeGuide;
          const note = document.createElement('span');
          note.textContent = config.dataset.fitHelp;
          const noteBase = `ktt-fit-help-${details.id || 'product'}`;
          let noteId = noteBase;
          let noteIndex = 1;
          while (document.getElementById(noteId)) noteId = `${noteBase}-${noteIndex++}`;
          note.id = noteId;
          link.setAttribute('aria-describedby', noteId);
          help.append(link, note);
          picker.prepend(help);
          link.addEventListener('click', () => {
            const id = link.getAttribute('href');
            if (!id?.startsWith('#')) return;
            const target = document.getElementById(id.slice(1));
            if (!target) return;
            for (let parent = target.parentElement; parent; parent = parent.parentElement) {
              if (parent instanceof HTMLDetailsElement) parent.open = true;
            }
            target.focus({ preventScroll: true });
          });
        }
        const link = help.querySelector('a');
        if (link.getAttribute('href') !== guide.href) link.setAttribute('href', guide.href);
      }
    };

    let frame = 0;
    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        enhance();
      });
    };
    enhance();
    const observer = new MutationObserver(schedule);
    observer.observe(main, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('variant:update', schedule);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeKttShopDesign, { once: true });
  } else {
    initializeKttShopDesign();
  }
  } catch(e) { console.error(e); }
})();

})();
